export default __webpack_public_path__ + "static/media/Bookerly-Regular.79f3811e.ttf";